export default __webpack_public_path__ + "static/hammer_b.0e78bdebec81c4dc589f5f02d93e20f9.png";